<template>
  <h2 class="screen_out">
    {{ props.pageData.defaultData.category }} - {{ props.pageData.defaultData.title }}
  </h2>
  <article
    id="mainContent"
    :class="['content-article', 'content-service', `content_${props.pageData.defaultData.page}`]"
  >
    <h3 class="screen_out">{{ props.pageData.defaultData.title }} 본문</h3>
    <BarProgressScroll />
    <!-- 최상단 타이틀 영역 -->
    <AreaTitleService :pageData="props.pageData" />
    <!-- 이미지 영역 -->
    <AreaVisualService :imageData="props.pageData.defaultData.image" />
    <!-- 텍스트 소개 영역 -->
    <AreaInfoService v-if="props.pageData.infoData.class!=='ty_ito'" :infoData="props.pageData.infoData" />
    <!-- 경험 박스 영역 -->
    <div class="area_experience">
      <div class="inner_area">
        <h4
          class="tit_area"
          v-html="props.pageData.experienceData.title"
        ></h4>
        <div class="inner_experience">
          <div
            v-for="(item, index) in props.pageData.experienceData.list"
            :key="`item_${index}`"
          >
            <div class="wrap_image">
              <img
                :src="item.image"
                alt=""
              />
            </div>
            <div
              v-for="(subItem, subIndex) in item.data"
              :key="`subItem_${subIndex}`"
              class="item_experience"
            >
              <em>{{ subItem.name }}</em>
              <p>{{ subItem.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 프로세스 영역 -->
    <div class="area_process">
      <div class="inner_area">
        <h4
          class="tit_area"
          v-html="props.pageData.processData.title"
        ></h4>
        <div class="wrap_image">
          <img
            :src="processImage"
            :alt="props.pageData.processData.description"
          />
        </div>
      </div>
    </div>
    <!-- 텍스트 소개 영역 -->
    <AreaInfoService v-if="props.pageData.infoData.class==='ty_ito'" :infoData="props.pageData.infoData" />
    <!-- 관련 고객사례 리스트 -->
    <AreaRelatedService :service="props.service" />
    <!-- 배너영역 -->
    <div class="area_banner">
      <BannerConsult :logInfo="{ page: 'detail', name: '상세페이지' }" />
    </div>
  </article>
</template>
<script setup>
const props = defineProps({
  pageData: {
    type: Object,
    default() {
      return {};
    },
  },
  service: {
    type: String,
    required: true,
  },
});

useHead({
  title: `${props.pageData.defaultData.title} | 비즈니스 - dk techin`,
  meta: [
    {
      name: 'description',
      content: `${props.pageData.seoData.description}`,
    },
    {
      property: 'og:title',
      content: `${props.pageData.defaultData.title} | 비즈니스 - dk techin`,
    },
    {
      property: 'og:description',
      content: `${props.pageData.seoData.description}`,
    },
  ],
});

import { useIsWidth } from '/stores/store';
const isWidthStore = useIsWidth();

const processImage = computed(() => {
  const width = isWidthStore.resolutionList;
  const processInfo = props.pageData.processData.image;
  if (width.isPc) return processInfo.pc;
  if (width.isTablet) return processInfo.tablet;
  return processInfo.mo;
});
</script>
<style lang="scss" scoped>
.inner_area {
  //공통 래퍼사이즈 스타일넣기
  max-width: 1104px;
  margin: 0 auto;
  padding: 0 40px;
}
.tit_area {
  font-size: 36px;
  line-height: 1.39;
  letter-spacing: -2px;
  word-break: keep-all;
}
.area_experience {
  padding: 180px 0;
  .inner_experience {
    display: flex;
    gap: 24px;
    margin-top: 80px;
    & > div {
      flex-basis: 50%;
    }
  }
  .wrap_image {
    overflow: hidden;
    border-radius: 50px;
    margin-bottom: 60px;
    line-height: 1px;
    img {
      width: 100%;
    }
  }
  .item_experience {
    padding: 0 24px;
    & + .item_experience {
      margin-top: 40px;
    }
    em {
      font-weight: 700;
      font-size: 28px;
      line-height: 1.46;
      letter-spacing: -0.5px;
      color: #1d1d1f;
    }
    p {
      margin-top: 12px;
      font-size: 20px;
      letter-spacing: -0.5px;
      font-weight: 400;
      color: #666;
    }
  }
}
.area_process {
  padding: 160px 0;
  background-color: #f5f5f5;
  .wrap_image {
    margin-top: 80px;
    img {
      width: 100%;
    }
  }
}
@media screen and (max-width: 1023px) {
  .area_experience {
    .inner_experience {
      flex-direction: column;
      gap: 80px;
    }
  }
}
@media screen and (max-width: 811px) {
  .inner_area {
    padding: 0 20px;
  }
  .tit_area {
    font-size: 24px;
    letter-spacing: -0.5px;
    line-height: 1.5;
    text-align: center;
  }
  .area_experience {
    padding: 80px 0;
    .wrap_image {
      border-radius: 8px;
      margin-bottom: 40px;
    }
    .item_experience {
      padding: 0;
      & + .item_experience {
        margin-top: 24px;
      }
      em {
        font-size: 18px;
      }
      p {
        font-size: 14px;
      }
    }
  }
  .area_process {
    padding: 80px 0;
    .wrap_image {
      margin-top: 40px;
      img {
        width: 100%;
      }
    }
  }
}
</style>
